//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import AdditionalBlock from './AdditionalBlock.vue'
export default {
  components: {
    AdditionalBlock
  },
  props: {
    routeSources: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    hasInfo: function () {
      return this.routeSources && this.routeSources.length > 0
    }
  }
}
